<template>
  <div class="zone">
    <TJDetailTitle :titleData="'销量统计_经销商'" />
    <functionBox 
    :totalText="'总计人份数：'+ $tool.moneyFormatter(Number(sumPeople), 0) +'人份 总计金额：'+ $tool.moneyFormatter(Number(sumRMB), 2) +'元'"
    :titleData="{permission_flag:'Sales',nowID:2}"
      :searhLoading="loading"
      @searchBtn="searchBtn"
    >
    <template>
      <li>
        <ProvinceSelect @selectedProvince="handleSelectedProvince"></ProvinceSelect>
      </li>
      <li>
        <el-select
            v-model="customer_id"
            placeholder="请选择经销商"
            size="small"
            filterable
            clearable
            style="margin-left: 10px"
            :remote="province_id==''"
            :remote-method="search_customerFun"
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.customer_id"
              :label="item.customer_name"
              :value="item.customer_id"
            ></el-option>
          </el-select>
      </li>
      <li>
        <timePicker @setTime="setTime"></timePicker>
      </li>
    </template>
  </functionBox> 
    <!-- <div class="indent">
      <div class="indentone">
        <div class="left cursor" @click="toSales">省份</div>
        <div class="line"></div>
        <div class="spital cursor">经销商</div>
        <div class="line"></div>
        <div class="Volume cursor" @click="toVolume">报告</div>
        <div class="line"></div>
        <div class="Device cursor" @click="toTurnover">日成交量</div>
        <p class="NumCla">总计人份数： {{ $tool.moneyFormatter(Number(sumPeople), 2) }}人份 总计金额： {{ $tool.moneyFormatter(Number(sumRMB), 2) }}元</p>
      </div>
      <div class="below">
        <div class="city">
          <el-select
            v-model="province_id"
            placeholder="请选择省份"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="customer_id"
            placeholder="请选择经销商"
            size="small"
            filterable
            clearable
            style="margin-left: 10px"
            remote
            :remote-method="search_customerFun"
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.customer_id"
              :label="item.customer_name"
              :value="item.customer_id"
            ></el-option>
          </el-select>
        </div>

        <timePicker @setTime="setTime"></timePicker>
        <div class="seachone">
          <el-button type="primary" size="small" @click="searchBtn">
            搜索
          </el-button>
        </div>
      </div>
    </div> -->

    <div class="sheet">
      <el-table
        :data="tableData"
        stripe
        height="700"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          height="30"
          width="100"
          align="center"
        >
          <template scope="scope">
            <!-- <span>{{scope.$index }}</span> -->
            <span>{{ serialtext(scope.$index) }}</span>

          </template>
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="经销商"
          height="30"
          align="center"
        ></el-table-column>
        <el-table-column label="金额" align="center">
          <template slot-scope="scope">
            {{ $tool.moneyFormatter(Number(scope.row.orders_sum), 2) }}
          </template>
        </el-table-column>
        <el-table-column label="人份数" align="center">
          <template slot-scope="scope">
            {{ $tool.moneyFormatter(Number(scope.row.amount), 0) }}
          </template>
        </el-table-column>

        <el-table-column label="操作 " width="120" align="center">
          <template slot-scope="scope">
            <div class="caozuo">
              <el-tooltip
                effect="light"
                placement="left"
                popper-class="custom-tooltip-border"
                width="20"
                trigger="hover"
                content="构成分析"
              >
                <div
                  class="box"
                  @click="toComposition(scope.row, $event)"
                >
                  <img
                    src="@/assets/img/Composition.png"
                    alt=""
                    @mouseenter="hoverC('lanse1', $event)"
                    @mouseleave="hoverC('Composition', $event)"
                  />
                </div>
              </el-tooltip>
              |
              <el-tooltip
                effect="light"
                placement="left"
                popper-class="custom-tooltip-border"
                width="30"
                trigger="hover"
                content="时序分析"
              >
                <div
                  class="box"
                  @click="toseries(scope.row, $event)"
                >
                  <img
                    src="@/assets/img/series.png"
                    alt=""
                    @mouseenter="hoverC('lanse2', $event)"
                    @mouseleave="hoverC('series', $event)"
                  />
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="el_pagination_style">
        <el-pagination
          :hide-on-single-page="total <= 0"
          background
          layout="total,prev, pager, next,jumper"
          :total="total"
          :current-page.sync="page"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/tongji'
import TJDetailTitle from '@/components/TJDetailTitle'
import timePicker from '@/components/timePicker'
import functionBox from './components/functionBox.vue'
import { getsale_nationwide } from '@/router/menuMain.js'
import ProvinceSelect from "@/components/ProvinceSelect.vue";

export default {
  components: {ProvinceSelect, TJDetailTitle,timePicker,functionBox },
  name: 'Agency',
  data() {
    return {
      options: JSON.parse(localStorage.getItem('province')), //地区列表
      province_id: '', //地区选择值

      customerOptions: [], //经销商下拉表
      customer_id: '', //经销商下拉表-值

      radio: '年', //时间节点
      start_stats_year: '', //开始年份
      end_stats_year: '', //结束年份
      dateMonthValue: '', //月份和日期选择
      page: 1,
      size: 10,
      total: 0,

      loading: false, //加载动画
      tableData: [],
      nationData: {},//全国数据
      sumPeople: 0,//总人份数
      sumRMB: 0,//总金额
      sale_nationwide: false,
      customerAllList: [],

    }
  },
  computed: {
    type() {
      const arr = {
        年: 'year',
        月: 'monthrange',
        日: 'daterange',
      }
      return arr[this.radio]
    },
    startPlaceholder() {
      const arr = {
        年: '开始年份',
        月: '开始月份',
        日: '开始日期',
      }
      return arr[this.radio]
    },
    endPlaceholder() {
      const arr = {
        年: '结束年份',
        月: '结束月份',
        日: '结束日期',
      }
      return arr[this.radio]
    },
    format() {
      const arr = {
        年: 'yyyy',
        月: 'yyyy/MM',
        日: 'yyyy/MM/dd',
      }
      return arr[this.radio]
    },
    formatValue() {
      const arr = {
        年: 'yyyy',
        月: 'yyyyMM',
        日: 'yyyyMMdd',
      }
      return arr[this.radio]
    },
    serialtext() {
      return (index)=>{
        if(this.sale_nationwide){
          if(index == 0) {
            return 0
          }else{
            return (this.page-1)*10+index
          }
        }else{
          return (this.page-1)*10+index+1
        }
      }
    },
  },
  watch: {
    // type() {
    //   this.start_stats_year = ''
    //   this.end_stats_year = ''
    //   this.dateMonthValue = ''
    // },
  },
  created() {
    this.sale_nationwide = getsale_nationwide();
    this.getCustomerAllList();
  },
  mounted() {
    this.search_customerFun('')
    // 延迟来让时间组件加载出来
    setTimeout(() => {
      // this.customer_daily_trade_sumFun()
      this.customer_daily_trade_entireFun();
    }, 200);
  },
  methods: {
    handleSelectedProvince(val){
      this.province_id = val
    },
    // 根据回调修改当前页的相关属性
    setTime(val) {
      this[val.name] = val.value
    },
    // 根据省份获取医院列表
    getCustomerAllList() {
      api.customer({ size: "all" }).then((res) => {
        if (res.code === 200) {
          this.customerAllList = res.data;
        }
      });
    },
    changeProvince() {
      this.customer_id='';
      this.customerOptions = this.province_id?this.customerAllList.filter(e => this.province_id == e.province_id):[]

    },
    // 获取所有经销商数据字典
    search_customerFun(e) {
      api.search_customer({ customer_name: e }).then((res) => {
        this.customerOptions = res.data
      })
    },
    // 全国统计
    customer_daily_trade_entireFun() {
      this.loading = true

      if(this.sale_nationwide){
        let param = {
          ...this.filterQuery(),
        }
        api.customer_daily_trade_entire(param).then(res => {
          if(res.code == 200) {
            this.nationData = {
              amount: res.data.amount_cnt,
              customer: "",
              customer_name: res.data.customer_name,
              orders_sum: res.data.orders_cnt,
            }
          }

          this.customer_daily_trade_sumFun();
        }).catch(err => {
          this.customer_daily_trade_sumFun();
        })
      }else {
        this.customer_daily_trade_sumFun();
      }
    },


    // 省份销量统计省份所占百分比
    customer_daily_trade_sumFun() {
      this.loading = true
      let param = {
        province_id: this.province_id, //地区ID
        customer_id: this.customer_id, //经销商id
        page: this.page,
        size: this.size,
        ...this.filterQuery(),
      }
      api.customer_daily_trade_sum(param).then((res) => {
        let data = res.data.data
        this.tableData = data
        if(this.nationData.customer_name){
          this.tableData.unshift(this.nationData);
        }
        this.total = res.data.count
        this.loading = false
        this.sumRMB = res.data.orders_cnt;
				this.sumPeople = res.data.amount_cnt;
      }).catch(err=>{
        this.loading = false
      })
    },

    // 年份联动选择处理,开始年份>结束年份
    changeYearData() {
      if (
        this.end_stats_year != '' &&
        this.start_stats_year > this.end_stats_year
      ) {
        this.end_stats_year = '' //结束年份
      }
    },

    // 搜索按钮
    searchBtn() {
      this.page = 1
      // this.customer_daily_trade_sumFun()
      //  改变搜索条件后，先获取全国，再自动获取其他数据。
      this.customer_daily_trade_entireFun();
    },

    // 翻页
    handleCurrentChange(val) {
      this.page = val
      this.customer_daily_trade_sumFun()
    },

    // 鼠标放在操作图标时
    hoverC(a, e) {
      e.target.src = require('@/assets/img/' + a + '.png')
    },

    // 跳转页面携带参数处理
    filterQuery() {
      let param = {
        date_type: '', //日期类型:0:年,1,月,2,日
      }
      if (this.radio == '年') {
        param.start_stats_year = this.start_stats_year
        param.end_stats_year = this.end_stats_year
        param.date_type = 0
      } else if (this.radio == '月') {
        param.start_stats_month =
          this.dateMonthValue != null ? this.dateMonthValue[0] : ''
        param.end_stats_month =
          this.dateMonthValue != null ? this.dateMonthValue[1] : ''
        param.date_type = 1
      } else if (this.radio == '日') {
        param.start_stats_day =
          this.dateMonthValue != null ? this.dateMonthValue[0] : ''
        param.end_stats_day =
          this.dateMonthValue != null ? this.dateMonthValue[1] : ''
        param.date_type = 2
      }
      return param
    },

    // 跳转-构成分析-页面
    toComposition(item, e) {
      this.hoverC('Composition', e)
      let query = {
        province_id: this.province_id, //地区ID
        customer_id: item.customer,
        customer_name: item.customer_name,
        ...this.filterQuery(),
        date_type: this.radio,
      }
      this.$router.push({ path: '/AgencyComposition', query })
    },
    // 跳转-时序分析--页面
    toseries(item, e) {
      this.hoverC('series', e)
      let query = {
        province_id: this.province_id, //地区ID
        customer_id: item.customer,
        customer_name: item.customer_name,
        ...this.filterQuery(),
        date_type: this.radio,
      }
      this.$router.push({ path: '/AgencyTime', query })
    },

    toVolume() {
      this.$router.push({ path: '/Volume' })
    },
    toSales() {
      this.$router.push({ path: '/Sales' })
    },

    toTurnover() {
      this.$router.push({ path: '/Turnover' })
    },

    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' '
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
  },
}
</script>

<style lang="scss" scoped>
.el-table {
  .caozuo {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 40px;
    color: #d0d7e0;
    .box {
      width: 36px;
      height: 36px;
    }
    img {
      width: 36px;
      height: 36px;
    }
  }
}
.indent {
  height: px(121);
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(51, 64, 79, 0.1);
  border-radius: 5px;
  margin-bottom: px(20);
  padding: px(15);
  .indentone {
    width: 100%;
    height: px(56);
    display: flex;
    border-bottom: 1px solid #d0d7e0;
    margin-bottom: px(15);
    .NumCla{
      justify-content: end;
      width: 70%;
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #111111;
      margin-right: px(20);
    }
    .cursor {
      cursor: pointer;
    }
    .left {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      margin-right: px(20);
      font-weight: bold;
      color: #666666ff;
    }
    .spital {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      font-weight: bold;
      margin-right: px(20);
      color: #111111;
    }
    .Volume {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #666666ff;
      margin-right: px(20);
    }
    .Device {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #666666ff;
      margin-right: px(20);
    }

    .line {
      width: 1px;
      height: 13px;
      background-color: rgba(208, 215, 224, 1);
      margin-top: px(16);
      margin-right: px(20);
    }
  }
}
.below {
  //height: px(36);
  display: flex;
}
.calendar {
  margin-left: px(10);
}
.cityProvince {
  margin-left: px(10);
}
.calendarone {
  display: flex;
  margin-left: px(10);
}
.seachone {
  margin-left: px(10);
}
.sheet {
  border-radius: px(10);
  background-color: #fff;
  margin-bottom: px(23);
}
.combination {
  font-size: px(16);
  color: #333333;
  margin-top: px(10);
}
::v-deep .el-table__footer-wrapper .cell {
  font-size: px(14);
  font-weight: bold;
  color: #006ed0ff;
}
</style>
<style>
.custom-tooltip-border{
  border: 1px solid #8f9297!important;
}
</style>
